import tippy from 'tippy.js';
import { Injectable, InjectionToken, Directive, Input, ElementRef, Inject, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
class TooltipService {
    constructor() {
        // tslint:disable-next-line:variable-name
        this._instances = new Map();
        this.groups = new Map();
    }
    /**
     * @return {?}
     */
    get instances() {
        return this._instances;
    }
    /**
     * Returns given group TooltipInstance collection
     * @param {?} group id of group collection to be retrieved
     * @return {?}
     */
    getGroup(group) {
        return this.groups.get(group);
    }
    /**
     * Adds `TooltipInstance` to collections.
     * Used for internal module functionality, so should be used with caution.
     * @param {?} instance `TooltipInstance` to be added
     * @return {?}
     */
    addInstance(instance) {
        if (instance && instance.id) {
            if (!this.instances.has(instance.id)) {
                this.instances.set(instance.id, instance);
                if (instance.group) {
                    this.addGroupInstance(instance);
                }
            }
            else {
                console.error('TooltipInstance already exists in collection: cannot be added to collection');
            }
        }
        else {
            console.error('TooltipInstance missing necessary \'id\ property: cannot be added to collection');
        }
    }
    /**
     * Adds `TooltipInstance` to group collection.
     * Used for internal module functionality, so should be used with caution.
     * @param {?} instance `TooltipInstance` to be added
     * @return {?}
     */
    addGroupInstance(instance) {
        if (instance.group) {
            if (!this.groups.has(instance.group)) {
                this.groups.set(instance.group, new Map());
            }
            this.groups.get(instance.group).set(instance.id, instance);
        }
        else {
            console.error('TooltipInstance missing necessary \'group\ property: cannot be added to group collection');
        }
    }
    /**
     * Removes `TooltipInstance` from collection.
     * Used for internal module functionality, so should be used with caution.
     * @param {?} id unique numeric `TooltipInstance` id
     * @param {?=} group if provided, `TooltipInstance` will be removed from group collection as well as global instance collection.
     * @return {?}
     */
    removeInstance(id, group) {
        if (this.instances.has(id)) {
            this.instances.delete(id);
        }
        else {
            console.error('TooltipInstance does not exist in collection: cannot be removed from collection');
        }
        if (group) {
            this.removeGroupInstance(id, group);
        }
    }
    /**
     * Removes `TooltipInstance` from group collection.
     * Used for internal module functionality, so should be used with caution.
     * @param {?} id unique numeric `TooltipInstance` id
     * @param {?} group group id of the collection from which the TooltipInstance will be removed.
     * @return {?}
     */
    removeGroupInstance(id, group) {
        if (this.groups.has(group)) {
            if (this.groups.get(group).has(id)) {
                this.groups.get(group).delete(id);
            }
            else {
                console.error('TooltipInstance does not exist in group collection: cannot be removed from group collection');
            }
        }
        else {
            console.error('Group does not exist in group collection: cannot remove TooltipInstance');
        }
    }
    /**
     * Hides all `TooltipInstance`s generated thus far.
     * @param {?=} options
     * @param {?=} group group id which, if provided, causes function to affect only those instances belonging to the group.
     * @return {?}
     */
    hideAll(options, group) {
        if (group && this.groups.has(group)) {
            this.groups.get(group).forEach((/**
             * @param {?} instance
             * @return {?}
             */
            instance => instance.hide()));
        }
        else {
            tippy.hideAll(options);
        }
    }
    /**
     * Shows all `TooltipInstance`s generated thus far.
     * @param {?=} duration
     * @param {?=} group group id which, if provided, causes function to affect only those instances belonging to the group.
     * @return {?}
     */
    showAll(duration, group) {
        (this.groups.get(group) || this.instances).forEach((/**
         * @param {?} instance
         * @return {?}
         */
        instance => instance.show(duration)));
    }
    /**
     * Disables all `TooltipInstance`s generated thus far.
     * @param {?=} group group id which, if provided, causes function to affect only those instances belonging to the group.
     * @return {?}
     */
    disableAll(group) {
        (this.groups.get(group) || this.instances).forEach((/**
         * @param {?} instance
         * @return {?}
         */
        instance => instance.disable()));
    }
    /**
     * Enables all `TooltipInstance`s generated thus far.
     * Tooltips without content remain disabled to prevent empty tooltips from being displayed.
     * @param {?=} group group id which, if provided, causes function to affect only those instances belonging to the group.
     * @return {?}
     */
    enableAll(group) {
        (this.groups.get(group) || this.instances).forEach((/**
         * @param {?} instance
         * @return {?}
         */
        instance => {
            if (instance.props.content) {
                instance.enable();
            }
        }));
    }
    /**
     * Destroys all `TooltipInstance`s generated thus far, and clears the collection.
     * @param {?=} group group id which, if provided, causes function to affect only those instances belonging to the group.
     * @return {?}
     */
    destroyAll(group) {
        if (group && this.groups.has(group)) {
            this.groups.get(group).forEach((/**
             * @param {?} instance
             * @return {?}
             */
            instance => {
                this.instances.delete(instance.id);
                instance.destroy();
            }));
            this.groups.get(group).clear();
        }
        else {
            this.instances.forEach((/**
             * @param {?} instance
             * @return {?}
             */
            instance => instance.destroy()));
            this.instances.clear();
        }
    }
}
TooltipService.ɵfac = function TooltipService_Factory(t) { return new (t || TooltipService)(); };
TooltipService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: TooltipService, factory: TooltipService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TooltipService, [{
        type: Injectable
    }], function () { return []; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/*
 * This is not a real service, but it looks like it from the outside.
 * It's just an InjectionToken used to import the config (initOptions) object, provided from the outside
 */
/** @type {?} */
const TooltipOptionsService = new InjectionToken('TooltipOptions');

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class TooltipDirective {
    /**
     * @param {?} initOptions
     * @param {?} el
     * @param {?} tooltipService
     */
    constructor(initOptions, el, tooltipService) {
        this.initOptions = initOptions;
        this.el = el;
        this.tooltipService = tooltipService;
        this.options = {};
        this.tooltipInstance = null;
        this.create();
        this.updateOptions(this.options);
    }
    /**
     * @param {?} options
     * @return {?}
     */
    set tooltipOptions(options) {
        this.updateOptions(options);
    }
    /**
     * @return {?}
     */
    get tooltipOptions() {
        return this.options;
    }
    /**
     * @param {?} group
     * @return {?}
     */
    set tooltipGroup(group) {
        this.updateOptions({ group });
    }
    /**
     * @return {?}
     */
    get tooltipGroup() {
        return this.options.group;
    }
    /**
     * @param {?} content
     * @return {?}
     */
    set tooltipContent(content) {
        this.updateOptions({ content });
    }
    /**
     * @return {?}
     */
    get tooltipContent() {
        return this.options.content;
    }
    /**
     * @param {?} arrowType
     * @return {?}
     */
    set tooltipArrowType(arrowType) {
        this.options.arrow = true;
        this.updateOptions({ arrowType });
    }
    /**
     * @return {?}
     */
    get tooltipArrowType() {
        return this.options.arrowType;
    }
    /**
     * @param {?} maxWidth
     * @return {?}
     */
    set tooltipMaxWidth(maxWidth) {
        this.updateOptions({ maxWidth });
    }
    /**
     * @return {?}
     */
    get tooltipMaxWidth() {
        return this.options.maxWidth;
    }
    /**
     * @param {?} placement
     * @return {?}
     */
    set tooltipPlacement(placement) {
        this.updateOptions({ placement });
    }
    /**
     * @return {?}
     */
    get tooltipPlacement() {
        return this.options.placement;
    }
    /**
     * @param {?} animation
     * @return {?}
     */
    set tooltipAnimation(animation) {
        this.updateOptions({ animation });
    }
    /**
     * @return {?}
     */
    get tooltipAnimation() {
        return this.options.animation;
    }
    /**
     * @param {?} trigger
     * @return {?}
     */
    set tooltipTrigger(trigger) {
        this.updateOptions({ trigger });
    }
    /**
     * @return {?}
     */
    get tooltipTrigger() {
        return this.options.trigger;
    }
    /**
     * @param {?} touch
     * @return {?}
     */
    set tooltipTouch(touch) {
        this.updateOptions({ touch });
    }
    /**
     * @return {?}
     */
    get tooltipTouch() {
        return this.options.touch;
    }
    /**
     * @param {?} touchHold
     * @return {?}
     */
    set tooltipTouchHold(touchHold) {
        this.updateOptions({ touchHold });
    }
    /**
     * @return {?}
     */
    get tooltipTouchHold() {
        return this.options.touchHold;
    }
    /**
     * @param {?} theme
     * @return {?}
     */
    set tooltipTheme(theme) {
        this.updateOptions({ theme });
    }
    /**
     * @return {?}
     */
    get tooltipTheme() {
        return this.options.theme;
    }
    /**
     * @param {?} allowHTML
     * @return {?}
     */
    set tooltipAllowHtml(allowHTML) {
        this.updateOptions({ allowHTML });
    }
    /**
     * @return {?}
     */
    get tooltipAllowHtml() {
        return this.options.allowHTML;
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.destroy();
    }
    /**
     * @return {?}
     */
    get state() {
        return this.tooltipInstance ? this.tooltipInstance.state : {};
    }
    /**
     * @return {?}
     */
    get id() {
        return this.tooltipInstance ? this.tooltipInstance.id : undefined;
    }
    /**
     * @return {?}
     */
    get group() {
        return this.tooltipInstance ? this.tooltipInstance.group : undefined;
    }
    /**
     * Update the `TooltipInstance` options, and update the related state and collections.
     * @private
     * @param {?} options block of any or all new `TooltipOption` to be added to `TooltipInstance`
     * @return {?}
     */
    updateOptions(options) {
        // clean options object
        /** @type {?} */
        const previousGroup = this.group;
        this.options = this.cleanOptions(Object.assign({}, this.initOptions, this.options, options));
        const { group } = this.options;
        delete this.options.group; // group is not a valid tippy.js prop so must be removed
        // set options
        if (this.state.isEnabled) {
            if (this.options.content) {
                this.tooltipInstance.set(this.options);
            }
            else {
                this.disable(); // tooltips without content should be disabled
            }
            // ensure tooltip is only enabled if it has content
        }
        else if (this.options.content) {
            this.enable();
            return this.updateOptions(Object.assign({}, this.options, { group })); // retry update
        }
        // maintain group collections
        this.options.group = group;
        this.tooltipInstance.group = group;
        if (previousGroup !== group) {
            if (previousGroup) {
                this.tooltipService.removeGroupInstance(this.id, previousGroup);
            }
            if (group) {
                this.tooltipService.addGroupInstance(this.tooltipInstance);
            }
        }
    }
    /**
     * Cleans provided options object by deleting all `null` or `undefined` properties
     * @private
     * @param {?} options
     * @return {?}
     */
    cleanOptions(options) {
        for (const prop in options) {
            if (options[prop] === null || options[prop] === undefined) {
                delete options[prop];
            }
        }
        return options;
    }
    /**
     * Create new `TooltipInstance` and add to collections
     * @private
     * @return {?}
     */
    create() {
        this.tooltipInstance = (/** @type {?} */ (tippy(this.el.nativeElement)));
        this.tooltipService.addInstance(this.tooltipInstance);
    }
    /**
     * Destroy current `TooltipInstance` and remove from collections
     * @return {?}
     */
    destroy() {
        if (this.tooltipInstance) {
            this.tooltipInstance.destroy();
        }
        this.tooltipService.removeInstance(this.id, this.group);
        this.tooltipInstance = null;
    }
    /**
     * Enable current `TooltipInstance` or create new `TooltipInstance` if it doesn't yet exits.
     * @return {?}
     */
    enable() {
        if (this.tooltipInstance) {
            this.tooltipInstance.enable();
        }
        else {
            this.create();
        }
    }
    /**
     * Disable current `TooltipInstance`
     * @return {?}
     */
    disable() {
        if (this.tooltipInstance) {
            this.tooltipInstance.disable();
        }
    }
    /**
     *  Show current `TooltipInstance`. Ignores enabled status.
     * @param {?=} duration length in milliseconds of show animation
     * @return {?}
     */
    show(duration) {
        if (this.tooltipInstance) {
            this.tooltipInstance.show(duration);
        }
    }
    /**
     * Hide current `TooltipInstance`
     * @param {?=} duration length in milliseconds of hide animation
     * @return {?}
     */
    hide(duration) {
        if (this.tooltipInstance) {
            this.tooltipInstance.hide(duration);
        }
    }
}
TooltipDirective.ɵfac = function TooltipDirective_Factory(t) { return new (t || TooltipDirective)(ɵngcc0.ɵɵdirectiveInject(TooltipOptionsService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(TooltipService)); };
TooltipDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: TooltipDirective, selectors: [["", "ngxTooltip", ""]], inputs: { tooltipOptions: ["ngxTooltip", "tooltipOptions"], tooltipGroup: "tooltipGroup", tooltipContent: "tooltipContent", tooltipArrowType: "tooltipArrowType", tooltipMaxWidth: "tooltipMaxWidth", tooltipPlacement: "tooltipPlacement", tooltipAnimation: "tooltipAnimation", tooltipTrigger: "tooltipTrigger", tooltipTouch: "tooltipTouch", tooltipTouchHold: "tooltipTouchHold", tooltipTheme: "tooltipTheme", tooltipAllowHtml: "tooltipAllowHtml" } });
/** @nocollapse */
TooltipDirective.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [TooltipOptionsService,] }] },
    { type: ElementRef },
    { type: TooltipService }
];
TooltipDirective.propDecorators = {
    tooltipOptions: [{ type: Input, args: ['ngxTooltip',] }],
    tooltipGroup: [{ type: Input }],
    tooltipContent: [{ type: Input }],
    tooltipArrowType: [{ type: Input }],
    tooltipMaxWidth: [{ type: Input }],
    tooltipPlacement: [{ type: Input }],
    tooltipAnimation: [{ type: Input }],
    tooltipTrigger: [{ type: Input }],
    tooltipTouch: [{ type: Input }],
    tooltipTouchHold: [{ type: Input }],
    tooltipTheme: [{ type: Input }],
    tooltipAllowHtml: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TooltipDirective, [{
        type: Directive,
        args: [{
                selector: '[ngxTooltip]'
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [TooltipOptionsService]
            }] }, { type: ɵngcc0.ElementRef }, { type: TooltipService }]; }, { tooltipOptions: [{
            type: Input,
            args: ['ngxTooltip']
        }], tooltipGroup: [{
            type: Input
        }], tooltipContent: [{
            type: Input
        }], tooltipArrowType: [{
            type: Input
        }], tooltipMaxWidth: [{
            type: Input
        }], tooltipPlacement: [{
            type: Input
        }], tooltipAnimation: [{
            type: Input
        }], tooltipTrigger: [{
            type: Input
        }], tooltipTouch: [{
            type: Input
        }], tooltipTouchHold: [{
            type: Input
        }], tooltipTheme: [{
            type: Input
        }], tooltipAllowHtml: [{
            type: Input
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class TooltipModule {
    /**
     * @param {?} initOptions
     * @return {?}
     */
    static forRoot(initOptions) {
        return {
            ngModule: TooltipModule,
            providers: [
                {
                    provide: TooltipOptionsService,
                    useValue: initOptions,
                }
            ]
        };
    }
}
TooltipModule.ɵfac = function TooltipModule_Factory(t) { return new (t || TooltipModule)(); };
TooltipModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: TooltipModule });
TooltipModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [
        TooltipService,
    ], imports: [CommonModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TooltipModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                ],
                providers: [
                    TooltipService,
                ],
                declarations: [
                    TooltipDirective,
                ],
                exports: [
                    TooltipDirective,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TooltipModule, { declarations: function () { return [TooltipDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [TooltipDirective]; } }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { TooltipService, TooltipDirective, TooltipModule, TooltipOptionsService as ɵa };

